import { render, staticRenderFns } from "./problemStudentDetail.vue?vue&type=template&id=a563a9fa&scoped=true"
import script from "./problemStudentDetail.vue?vue&type=script&lang=js"
export * from "./problemStudentDetail.vue?vue&type=script&lang=js"
import style0 from "./problemStudentDetail.vue?vue&type=style&index=0&id=a563a9fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a563a9fa",
  null
  
)

export default component.exports